import React from "react";
import withContext from "../../withContext";
import axios from 'axios';
import { Link } from 'react-router-dom'

function isImageCached(url) {
  if (!url || typeof Image === 'undefined') return false;
  const img = new Image();
  img.src = url;
  return img.complete && img.naturalWidth > 0;
}

class ProductItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loaded: isImageCached(props.product && props.product.URLp) };
    this.imgRef = null;
  }

  componentDidMount() {
    if (!this.state.loaded && this.imgRef && this.imgRef.complete && this.imgRef.naturalWidth > 0) {
      this.setState({ loaded: true });
    }
  }

  async handleclick (id) {
      await axios.delete(`/deleteproduct/${id}`)
      .then(res => res.data)
    }
  render() {
    const { product, user } = this.props;
    const { loaded } = this.state;
  return (
    <div className="mx-auto productitem mt-5 card bg-dark text-white" style={{order : product.order}} >
        <div className="media">

              <div className="card-img">
                {!loaded && <div className="product-img-skeleton" />}
                <img
                  ref={el => this.imgRef = el}
                  className={`card-img product-img-fade${loaded ? ' product-img-loaded' : ''}`}
                  src={product.URLp}
                  alt={product.shortDesc}
                  onLoad={() => this.setState({ loaded: true })}
                  onError={() => this.setState({ loaded: true })}
                />
                <Link className="newover"  to={{pathname:`/painting/${product.id}`, aboutProps: {product}}}>
                  <div className="imgtext">
                    <div className="imgtexttop">
                    <h3>{product.name}</h3>
                    <h5>{product.shortDesc}</h5>
                    <h5>{product.price}€</h5>
                    </div>
                    <div className="imgtextbot">

                    <h4>Click to see the product page</h4>  
                    </div>   
                  </div>
                </Link>
              </div>
          <div className="media-content">

            <div className="is-clearfix">
                {user && user.accessLevel < 1 && (
                  <button className="button" onClick={()=>{this.handleclick(product.id)}}>
                    Delete product
                  </button>
               )}
            </div>
          </div>
        </div>
    </div>
  );
}};

export default withContext(ProductItem);